export default "__VITE_ASSET__C47w$00a__"